import React, { Component } from 'react';
import Menu from './Menu';

export default class Layout extends Component {
	render() {
		return (
			<div id="main_content" style={{ position: 'relative' }}>
				<Menu {...this.props} />
			</div>
		);
	}
}
